import { HttpTransport, type Transport } from "@compath/renderer";
import { config } from "../models/config";
import { authHeaders, jsonHeaders } from "./apiHeaders";

// A fetch that injects the auth headers on every BFF call. The renderer's HttpTransport takes a
// fetch impl, so no renderer change is needed to authorize requests.
function authedFetch(getToken: () => string | null): typeof fetch {
  return (input, init) => {
    const headers = new Headers(init?.headers ?? {});
    for (const [k, v] of Object.entries(authHeaders(getToken))) headers.set(k, v);
    return fetch(input, { ...init, headers });
  };
}

export function makeTransport(getToken: () => string | null): Transport {
  return new HttpTransport(config.apiBase, authedFetch(getToken));
}

// ---- Admin control-plane (not part of the renderer Transport interface) ----
export interface LinkAppRequest {
  namespace: string;
  name: string;
  image: string;
  port?: number;
  replicas?: number;
  exposeHost?: string;
  oauthProxy?: boolean;
  db?: boolean;
  minio?: boolean;
  openai?: boolean;
  displayName?: string;
  icon?: string;
  home?: string;
  purchaseUrl?: string;
}

export interface LinkAppResult {
  app: { id: string; name: string; baseUrl: string };
  namespace: string;
  commit: string;
  files: string[];
  nextSteps: string[];
}

export async function linkApp(
  getToken: () => string | null,
  req: LinkAppRequest,
): Promise<LinkAppResult> {
  const res = await fetch(`${config.apiBase}/api/admin/apps`, {
    method: "POST",
    headers: jsonHeaders(getToken),
    body: JSON.stringify(req),
  });
  if (!res.ok) {
    const detail = await res.json().catch(() => ({}));
    throw new Error(detail?.detail ?? detail?.error ?? `link failed (${res.status})`);
  }
  return res.json();
}
